<template>
  <div class="max-w-[40rem]">
    <!-- <div class="btn" @click="showGallery = !showGallery">
      {{ $t('shared.showImages') }}
    </div> -->
    <!-- <div class="flex gap-3 flex-wrap">
      <div v-for="image, imageKey in restaurant.images" :key="imageKey">
        <div class="rounded overflow-hidden w-32" @click="currentSlide = imageKey">
          <AtomImage :src="useCloudinaryImage(image, 320, 320, 'auto')" />
        </div>
      </div>
    </div> -->
    <!-- <hr class="my-2"> -->
    <RestaurantGalleryCarousel :restaurant="restaurant" />
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  }
})
</script>

<style lang="css">
swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  height: 20vh;
  font-size: 4rem;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
}
</style>
